export default () => ({
	listing: {
		searchTerm: null,
		page: 1
	}
})
